<template>
  <div class="error">
    <header-nav :linkId="activeNum"></header-nav>
		<div class="main">
			<img src="../assets/500.png" alt="">
      <p class="tip">程序错误，我们的程序猿正在全力抢修，将尽快修复！</p>
      <el-button class="btn-link" @click="handleBackToHome">返回首页</el-button>
		</div>
    <Footer></Footer>
  </div>
</template>

<script>
import headerNav from '../components/Header.vue'
import Footer from '../components/Footer.vue'
export default {
  name: 'Home',
  components: {
    headerNav,
    Footer
  },
  data() {
    return {
      activeNum: '4'
    }
  },
  methods: {
    handleBackToHome() {
      this.$router.push('/')
    }
  }
}
</script>

<style lang="less" scoped>
.error {
  .main {
    width: 1200px;
    margin: 170px auto 242px;
    text-align: center;
    .tip {
      margin: 40px 0 20px;
    }
    .btn-link {
      background: #B71C22;
      border: #B71C22;
      color: #fff;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/Error500.vue